@use "@fukuri-admins/ui/layout" as *;

.item {
  display: flex;
  @include typography('Jp/14_W3');

  .label {
    color: text('High');
  }
  .value {
    color: text('High');
  }
}

.column {
  flex-direction: column;
  gap: spacing('4');
}

.row {
  flex-direction: row;
  align-items: flex-start;
  gap: spacing('24');

  .label {
    width: 172px;
  }
}

// ヘルプアイコン付きラベルでテキストとアイコンを縦中央揃えにする（Table/HeadCell の非 sortable ヘッダーと同じ扱い）
.labelWithHelp {
  display: inline-flex;
  align-items: center;
}

.helpIcon {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: spacing('4');
  cursor: default;
  color: text('Low');

  // svgIcon クラスが color: text('High') を持つため、詳細度を上げて上書きする
  svg {
    color: inherit;
  }
}
